module.exports = __webpack_public_path__ + "img/grade-NG.bf69f28d.svg";